// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1qwCA","alertIcon":"ConfirmModal_alertIcon__2oIF_"};